import {
    Box,
    VStack,
    Text,
    Input,
    Button,
    Image,
    InputGroup,
    PinInput,
} from "@chakra-ui/react";

import {
    useState,
} from "react";

import {
    Eye,
    EyeOff,
} from "lucide-react";

import {
    useNavigate,
    useLocation,
} from "react-router-dom";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import Logo from "../../../../assets/logo.png";
import routes from "../../../../routes";

import {
    confirmPasswordResetAction,
} from "../../../../state/actions/authActions";

import {
    toaster,
} from "../../../../components/toaster";

import ActivityToast from "../../../../components/ActivityToast";

const ResetPasswordConfirmForm = () => {
    const navigate =
        useNavigate();

    const location =
        useLocation();

    const dispatch =
        useDispatch();

    const {
        loading,
    } = useSelector(
        (state) =>
            state.auth
    );

    const {
        user_id,
        email,
    } =
        location.state || {};

    const [
        otp,
        setOtp,
    ] = useState("");

    const [
        newPassword,
        setNewPassword,
    ] = useState("");

    const [
        confirmPassword,
        setConfirmPassword,
    ] = useState("");

    const [
        showPassword,
        setShowPassword,
    ] = useState(false);

    const handleSubmit =
        async () => {
            const result =
                await dispatch(
                    confirmPasswordResetAction(
                        {
                            user_id,
                            otp:
                                Number(
                                    otp
                                ),
                            new_password:
                                newPassword,
                            password_confirm:
                                confirmPassword,
                        }
                    )
                );

            if (
                result?.success
            ) {
                toaster.create({
                    render: () => (
                        <ActivityToast
                            type="success"
                            title="Password Updated"
                            description="Your password has been reset successfully."
                            timestamp="Just now"
                        />
                    ),
                });

                setTimeout(
                    () => {
                        navigate(
                            routes.login
                        );
                    },
                    1000
                );
            } else {
                toaster.create({
                    render: () => (
                        <ActivityToast
                            type="error"
                            title="Reset Failed"
                            description={
                                result?.error ||
                                "Unable to reset password."
                            }
                            timestamp="Just now"
                        />
                    ),
                });
            }
        };

    const isValid =
        otp.length === 6 &&
        newPassword &&
        confirmPassword;

    return (
        <Box p={20}>
            <Box
                textAlign="center"
                mb={10}
            >
                <Image
                    src={Logo}
                    h="52px"
                    mx="auto"
                    mb={12}
                />

                <Text
                    fontSize="48px"
                    fontWeight="700"
                    color="#071D54"
                >
                    Reset Password
                </Text>

                <Text
                    color="gray.600"
                    mt={3}
                >
                    Enter the OTP sent to
                    your email and choose
                    a new password.
                </Text>

                {email && (
                    <Text
                        mt={2}
                        color="#2453FF"
                        fontWeight="600"
                    >
                        {email}
                    </Text>
                )}
            </Box>

            <VStack gap={5}>
              <PinInput.Root
                    otp
                    type="numeric"
                    onValueChange={(e) =>
                        setOtp(
                            e.value.join("")
                        )
                    }
                >
                    <PinInput.HiddenInput />

                    <PinInput.Control>
                        <PinInput.Input index={0} />
                        <PinInput.Input index={1} />
                        <PinInput.Input index={2} />
                        <PinInput.Input index={3} />
                        <PinInput.Input index={4} />
                        <PinInput.Input index={5} />
                    </PinInput.Control>
                </PinInput.Root>

                <InputGroup
                    endElement={
                        showPassword ? (
                            <EyeOff
                                size={18}
                                cursor="pointer"
                                onClick={() =>
                                    setShowPassword(
                                        false
                                    )
                                }
                            />
                        ) : (
                            <Eye
                                size={18}
                                cursor="pointer"
                                onClick={() =>
                                    setShowPassword(
                                        true
                                    )
                                }
                            />
                        )
                    }
                >
                    <Input
                        size="lg"
                        placeholder="New Password"
                        type={
                            showPassword
                                ? "text"
                                : "password"
                        }
                        value={
                            newPassword
                        }
                        onChange={(
                            e
                        ) =>
                            setNewPassword(
                                e
                                    .target
                                    .value
                            )
                        }
                    />
                </InputGroup>

                <Input
                    size="lg"
                    placeholder="Confirm Password"
                    type={
                        showPassword
                            ? "text"
                            : "password"
                    }
                    value={
                        confirmPassword
                    }
                    onChange={(
                        e
                    ) =>
                        setConfirmPassword(
                            e.target
                                .value
                        )
                    }
                />

                <Button
                    w="100%"
                    size="lg"
                    bg="#2453FF"
                    color="white"
                    loading={
                        loading
                    }
                    loadingText="Resetting..."
                    disabled={
                        !isValid
                    }
                    onClick={
                        handleSubmit
                    }
                >
                    Reset Password
                </Button>
            </VStack>
        </Box>
    );
};

export default ResetPasswordConfirmForm;